<div class="d-flex justify-content-between align-items-center gap-half tag" [ngClass]="type">
  <div class="zero-text p-small-reg">{{ label }}</div>
  @if (isDeletable) {
    <web-design-system-icon class="d-flex cursor-pointer" name="cross" size="small" (click)="delete.emit()" />
  } @else if (iconName) {
    <web-design-system-icon class="d-flex" [name]="iconName" size="small" />
  }
</div>
